export const GET_FETCH_MESSAGES = 'GET_FETCH_MESSAGES'
export const SEARCH_ACTUAL_MESSAGES = 'SEARCH_ACTUAL_MESSAGES'
export const SEARCH_MESSAGES = 'SEARCH_MESSAGES'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const SEARCH_ARCHIVE_MESSAGES = 'SEARCH_ARCHIVE_MESSAGES'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
